module.exports = __webpack_public_path__ + "static/knowledge_garden_with_river-f41441c9a36a3f6e696a02ed9a0e20d8.png";